/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Insert_MissingInputs */



/**
* | output |
* | --- |
* | "Insert missing events" |
*
* @param {Event_Group_Sync_Insert_MissingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_insert_missing = /** @type {((inputs?: Event_Group_Sync_Insert_MissingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Insert_MissingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insert missing events")
	if (locale === "de") return /** @type {LocalizedString} */ ("Insert missing events")
	if (locale === "it") return /** @type {LocalizedString} */ ("Insert missing events")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Insert missing events")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insert missing events")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Insert missing events")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Insert missing events")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Insert missing events")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insert missing events")
	return /** @type {LocalizedString} */ ("Insert missing events")
});